<!-- 点名组件实现： 点名没有独立的组件来实现，我们提供了一套事件驱动的点名系统 -->

<template>
  <div>
    <div id="roll-call-dialog"></div>
    <a-modal v-model="visible" title="点名" :closable="false" ok-text="签到" cancel-text="取消" @ok="subModal" @cancel="visible = false">
      <div>
        请在{{ timeLeft }}秒内签到</div>
    </a-modal>
  </div>
</template>

<script>
import language from '../../language/main'

const auth = BJY.auth
const eventEmitter = BJY.eventEmitter

export default {
  components: {},
  data() {
    return {
      language: language,
      status: 0,
      isStudent: auth.isStudent(),
      applyTimer: null,
      timeLeft: '',
      result: '',
      visible: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    subModal() {
      eventEmitter.trigger(eventEmitter.ROLL_CALL_RES)
      this.visible = false
      this.$message.success('签到成功')
    },
  },
  created() {
    eventEmitter.on(
      eventEmitter.ROLL_CALL, // 老师发起了点名
      (e, data) => {
        this.timeLeft = data.duration
        this.visible = true
        // this.$Dialog
        //   .show({
        //     title: '点名',
        //     content: `请在<span id='roll-call-time-left'>${data.duration}</span>秒内响应`,
        //     confirmText: '答到',
        //   })
        //   .then(() => {
        //     eventEmitter.trigger(eventEmitter.ROLL_CALL_RES)
        //   })
        //   .catch((e) => {
        //     console.log(e)
        //   })

        this.applyTimer = setInterval(() => {
          if (this.timeLeft === 0) {
            clearInterval(this.applyTimer)
            this.visible = false
            // this.$Dialog.hide()
          }
          $('#roll-call-time-left').text(this.timeLeft)
          this.timeLeft--
        }, 1000)
      }
    )
  },
  mounted() { },
  beforeDestroy() { },
}
</script>

<style lang="scss" scoped>
//@import url() 引入公共css类
</style>
